import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateQuantity } from "../../store/cartSlice";
import "../../style/common/number.scss";
import AddIcon from "../../icon/AddIcon";
import SubIcon from "../../icon/SubIcon";

const Number = (props) => {
  const dispatch = useDispatch();
  return (
    <React.Fragment>
      <div className="number">
        <div
          className="btn"
          onClick={() =>
            dispatch(updateQuantity({ id: props.id, quantity: -1 }))
          }
        >
          
          <SubIcon size={13} color="#000"/>
        </div>
        <div className="num">{props.num}</div>
        <div
          className="btn"
          onClick={() =>
            dispatch(updateQuantity({ id: props.id, quantity: 1 }))
          }
        >
          <AddIcon size={13} color="#000"/>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Number;
